export enum VolumeConstraintOperationType {
  GreatOrEqual = 0,
  Great = 1,
  Less = 2,
  LessOrEqual = 3,
  Equal = 4,
}
